import React, { useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useForm } from "react-hook-form";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { createPersonalDetails } from "../../../helpers/urlConfig/apiFunctions";
import { successToastify } from "../../../Components/Common/Toaster";
import { getSessionData } from "../../../helpers/sessionDetailsParser";
import errorResponseHandler from "../../../helpers/errorResponseHandler";

function PersonalDetailsCreate({
  modal_list,
  setmodal_list,
  tog_list,
  fetchData,
}) {
  const { register, handleSubmit, reset } = useForm();
  const [logo, setLogo] = useState("");

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setLogo(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const onSubmit = async (data) => {
    try {
      data.created_by = getSessionData("user_id");
      data.logo = logo; // Add encoded image to data object
      const response = await createPersonalDetails(data);

      if (response.statusCode === 200) {
        fetchData();
        setmodal_list(false);
        successToastify("Personal Details created successfully");
        reset();
        setLogo(""); // Reset logo state
      } else {
        errorResponseHandler(response);
      }
    } catch (error) {
      console.error("Error adding personal details:", error);
    }
  };

  return (
    <>
      <ToastContainer />
      <Modal isOpen={modal_list} toggle={tog_list} centered>
        <ModalHeader className="bg-light p-3" toggle={tog_list}>
          Add Personal Information
        </ModalHeader>
        <form className="tablelist-form" onSubmit={handleSubmit(onSubmit)}>
          <ModalBody>
            <div className="mb-3">
              <label htmlFor="customername-field" className="form-label">
                Owner Name
              </label>
              <input
                type="text"
                id="customername-field"
                className="form-control"
                placeholder="Enter Owner Name"
                required
                {...register("name", { required: "Owner Name is required" })}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="bank-field" className="form-label">
                Bank Name
              </label>
              <input
                type="text"
                id="bank-field"
                className="form-control"
                placeholder="Enter Bank Name"
                required
                {...register("bank", { required: "Bank Name is required" })}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="acc-no-field" className="form-label">
                Account Number
              </label>
              <textarea
                id="acc-no-field"
                className="form-control"
                placeholder="Enter Account Number"
                required
                {...register("acc_no", {
                  required: "Account Number is required",
                })}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="ifsc-field" className="form-label">
                IFSC Code
              </label>
              <input
                type="text"
                id="ifsc-field"
                className="form-control"
                placeholder="Enter IFSC Code"
                {...register("ifsc_code")}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="branch-field" className="form-label">
                Branch
              </label>
              <input
                type="text"
                id="branch-field"
                className="form-control"
                placeholder="Enter Branch"
                {...register("branch")}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="logo-field" className="form-label">
                Upload Logo
              </label>
              <input
                type="file"
                id="logo-field"
                className="form-control"
                accept="image/*"
                onChange={handleImageUpload}
              />
              {logo && (
                <img
                  src={logo}
                  alt="Logo Preview"
                  className="mt-2"
                  style={{ maxWidth: "100px" }}
                />
              )}
            </div>
          </ModalBody>
          <ModalFooter>
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => setmodal_list(false)}
              >
                Close
              </button>
              <button type="submit" className="btn btn-success" id="add-btn">
                Add Personal Details
              </button>
            </div>
          </ModalFooter>
        </form>
      </Modal>
    </>
  );
}

export default PersonalDetailsCreate;
